import { useState } from "react";
import { useUserContext } from "../../context/UserContext";
import Checks from "./Checks";
import HeaderPanel from "./HeaderPanel";
import TestHistoryModal from "./TestHistoryModal";

export default function ControlPanel() {
  const { isTesting, checksData } = useUserContext();
  const [showHistoryModal, setShowHistoryModal] = useState(false);
  const showResults = isTesting || Object.keys(checksData).length > 0;

  return (
    <div className="flex flex-col w-full min-h-full min-w-0 px-6 py-6 md:px-8">
      <div className="shrink-0 mb-5">
        <HeaderPanel onViewHistory={() => setShowHistoryModal(true)} />
      </div>

      {showHistoryModal ? (
        <TestHistoryModal
          visible
          onClose={() => setShowHistoryModal(false)}
        />
      ) : (
        showResults && (
          <div className="flex-1 min-w-0 min-h-0">
            <Checks />
          </div>
        )
      )}
    </div>
  );
}
